module.exports = "/images/logo-ppg.png?2cfa7ffc9fa3cbd5248758d82a9c4f87";